<template>
  <div class="customer-payment" @click="$emit('click', payment)">
    <div class="customer-payment__type">
      <span v-if="enable_payments_v2">{{ prefix }}</span>
      <strong>
        {{ pretty_type }}
      </strong>
      <div v-if="enable_payments_v2" class="customer-payment__date">
        {{ pretty_date }}
      </div>
    </div>

    <div v-if="!enable_payments_v2" class="customer-payment__date">
      {{ pretty_date }}
    </div>

    <div v-if="enable_payments_v2" class="customer-payment__notes_v2">
      {{ payment.notes }}
      <span v-if="payment.invoice_id"> - Fact: {{ invoice_code }}</span>
    </div>
    <div v-else class="customer-payment__notes">
      {{ payment.notes }}
      <span v-if="payment.invoice_id"> - Fact: {{ invoice_code }}</span>
    </div>

    <div class="flex-fill"></div>

    <div v-if="enable_payments_v2" class="customer-payment__remaining">
      {{ pretty_remaining }}
    </div>

    <div class="customer-payment__amount" :class="price_class">
      {{ pretty_amount }}
    </div>

    <div class="customer-payment__print">
      <a :href="payment_pdf_link" target="_blank">
        <i class="wabident icon-wabident-print"></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ["payment", "customer"],
  data() {
    return {};
  },
  computed: {
    price_class() {
      return {
        v2: this.enable_payments_v2,
        assignment:
          this.payment.amount >= 0 ? !this.is_deposit : this.is_deposit,
      };
    },
    is_deposit() {
      return this.payment.accounting_entry == "deposit";
    },
    prefix() {
      return (
        {
          deposit: "Aportación al Saldo",
          assignment: "Asignación a",
        }[this.payment.accounting_entry] || "N/D"
      );
    },
    payment_pdf_link() {
      return `/payment/${this.payment.id}/pdf`;
    },
    pretty_date() {
      return moment(this.payment.created_at).format("DD/MM/YY");
    },
    invoice_code() {
      if (this.payment.invoice_id && this.payment.invoice) {
        if (!this.payment.invoice.code) {
          return 'BORR' + this.payment.invoice.id;
        } else {
          return this.payment.invoice.code;
        }
      }
      return "";
    },

    pretty_type() {
      if (this.enable_payments_v2 && !this.is_deposit) {
        return this.payment.treatments
          .map((t) => {
            return t.full_name;
          })
          .join(" ");
      }

      const t = this.payment.type;
      const st = this.payment.subtype;

      const typename = this.clinic.payment_types[t].name;

      if (!typename) {
        return '';
      }

      let ret = typename;
      const subtype = this.clinic.payment_types[t].subtypes[st];
      if (subtype) {
        ret = ret + ' - ' + subtype;
      }

      return ret;
    },
    pretty_remaining() {
      if (!this.payment.remaining) return "";
      return WabiDent.fmtMoney(this.payment.remaining, 0);
    },
    pretty_amount() {
      let value = WabiDent.fmtMoney(this.payment.amount, 0);
      let prefix = "";

      if (this.enable_payments_v2) {
        if (this.payment.amount >= 0) {
          prefix = this.is_deposit ? "+" : "-";
        } else {
          value = WabiDent.fmtMoney(Math.abs(this.payment.amount), 0);
          prefix = this.is_deposit ? "-" : "+";
        }
      }

      return prefix + value;
    },
    enable_payments_v2() {
      if (!this.clinic) return false;
      return this.clinic.config.enable_payments_v2;
    },
    ...mapGetters(["clinic", "is_core"]),
  },
};
</script>

<style lang="scss">
.customer-payment {
  cursor: pointer;
  padding: 15px 10px;
  border-radius: 5px;
  background: var(--ui-gris-medio, #f9f9f8);
  margin-bottom: 10px;
  width: 100%;

  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;

  &__date {
    font-size: 14px;
    font-weight: 500;
    color: #a0a4b0;
    margin-right: 10px;
  }

  &__type {
    font-size: 16px;
    margin-right: 15px;
  }

  &__notes_v2 {
    font-size: 12px;
    font-weight: 500;
    margin-left: 30px;
    min-height: 6ch;
  }

  &__notes {
    font-size: 12px;
    font-weight: 500;
  }

  &__remaining {
    font-size: 12px;
    color: var(--theme-grey);
  }

  &__amount {
    flex: 0 1 100px;
    text-align: right;
    font-size: 20px;
    color: var(--theme-color-attended);
    margin-left: 30px;

    &.v2 {
      font-weight: bold;

      &.assignment {
        color: var(--theme-color-absent);
      }
    }
  }

  &__print {
    a {
      color: var(--theme-text-color);
      transition: color 0.2s;
      text-decoration: none;

      &:hover {
        color: var(--theme-color);
      }
    }

    padding-left: 10px;
  }
}
</style>
